const question3 = {
    'question': 'Z jakimi problemami warto zgłosić się do lekarza psychogeriatry?',
    'answer': 'Warto udać się do lekarza psychiatry osób starszych, kiedy zaobserwujemy nagłe zmiany w zachowaniu lub nastroju, takie jak wycofanie się z życia społecznego, utrata zainteresowań lub pogorszenie pamięci. Problemy z wykonywaniem codziennych czynności, takie jak samodzielne gotowanie, ubieranie się lub dbanie o higienę osobistą, halucynacje lub urojenia.',
}

export default question3;